import React from "react";
import { Box } from "@mui/material";
import { useCanvasInteraction } from "./hooks";
import { useActiveFloorContext } from "../Constant";
// const url = `http://54.158.123.107:8080/v1/assets/floor-plans/floor_plan_1750250152_8855.webp`;

const ImageToCanvas = ({droneNestClicked= null}) => {
  const {
    canvasRef,
    containerRef,
    position,
    isDragging,
    handleMouseDown,
    handleClick,
  } = useCanvasInteraction({droneNestClicked});
  const { action } = useActiveFloorContext();

  return (
    <Box
      ref={containerRef}
      sx={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        position: "relative",
      }}
      onMouseDown={handleMouseDown}
    >
      <canvas
        ref={canvasRef}
        onClick={handleClick}
        style={{
          cursor:
            action.type === "add"
              ? "crosshair"
              : action.type === "move"
              ? isDragging
                ? "grabbing"
                : "grab"
              : "default",
          position: "absolute",
          left: position.x,
          top: position.y,
          background: "#000000",
        }}
      />
    </Box>
  );
};

export default React.memo(ImageToCanvas);
